'use client';

import { PropsWithChildren, createContext, useContext, useMemo } from 'react';

export interface AppContextData {
  variant?: 'default' | 'error';
}

export const AppLayoutContext = createContext({} as AppContextData);

interface Props extends AppContextData, PropsWithChildren {}

export const AppLayoutContextProvider = (props: Props) => {
  const { children, variant = 'default' } = props;

  const value = useMemo(() => ({ variant }), [variant]);

  return (
    <AppLayoutContext.Provider value={value}>
      {children}
    </AppLayoutContext.Provider>
  );
};

export const useAppLayoutContext = () => {
  return useContext(AppLayoutContext);
};
